var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_726574496"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M108 190c2,0 3,-1 3,-3l0 -13c0,-1 -1,-3 -3,-3 -2,0 -3,2 -3,3l0 13c0,2 1,3 3,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M142 190c2,0 3,-1 3,-3l0 -13c0,-1 -1,-3 -3,-3 -2,0 -3,2 -3,3l0 13c0,2 1,3 3,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M125 190c2,0 3,-1 3,-3l0 -13c0,-1 -1,-3 -3,-3 -2,0 -3,2 -3,3l0 13c0,2 1,3 3,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M183 13l-100 0 0 -1c0,-7 -5,-12 -11,-12l-35 0c-6,0 -11,5 -11,12l0 1 -6 0c-11,0 -20,9 -20,20l0 128c0,12 9,21 20,21l64 0 2 7c3,8 11,14 20,14l38 0c10,0 17,-6 20,-14l2 -7 17 0c11,0 20,-9 20,-21l0 -128c0,-11 -9,-20 -20,-20zm-151 -1c0,-3 2,-6 5,-6l35 0c3,0 5,3 5,6l0 26 -45 0 0 -26zm-26 21c0,-8 7,-14 14,-14l6 0 0 19 -20 0 0 -5zm155 145c0,0 0,0 0,0l-3 9c-2,6 -7,10 -14,10l-38 0c-6,0 -12,-4 -14,-10l-2 -9c0,0 0,0 0,0l-4 -13 78 0 -3 13zm-79 -20c0,0 -1,0 -1,0l-1 0c-3,0 -5,-2 -5,-5 0,-3 2,-5 5,-5l25 0 0 10 -23 0 0 0zm29 0l0 -10 59 0c3,0 5,2 5,5 0,3 -2,5 -5,5l-1 0c0,0 0,0 0,0l-58 0 0 0zm0 -17l0 -14c0,-7 6,-14 14,-14 8,0 14,7 14,14l0 14 -28 0zm86 20c0,8 -6,14 -14,14l-15 0 3 -10c6,-1 11,-6 11,-12 0,-7 -5,-12 -12,-12l-25 0 0 -14c0,-11 -9,-20 -20,-20 -11,0 -20,9 -20,20l0 14 -25 0c-6,0 -12,5 -12,12 0,6 5,11 11,12l3 10 -62 0c-7,0 -14,-6 -14,-14l0 -116 191 0 0 116 0 0zm0 -123l-114 0 0 -19 100 0c8,0 14,6 14,14l0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M166 25c-2,0 -3,2 -3,4l0 0c0,2 1,3 3,3 2,0 3,-1 3,-3l0 0c0,-2 -1,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M179 25c-2,0 -4,2 -4,4l0 0c0,2 2,3 4,3 1,0 3,-1 3,-3l0 0c0,-2 -2,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M84 66l94 0c2,0 3,-1 3,-3 0,-2 -1,-3 -3,-3l-94 0c-2,0 -3,1 -3,3 0,2 1,3 3,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M153 25c-2,0 -3,2 -3,4l0 0c0,2 1,3 3,3 2,0 3,-1 3,-3l0 0c0,-2 -1,-4 -3,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M33 160l25 0c2,0 4,-1 4,-3 0,-2 -2,-3 -4,-3l-25 0c-3,0 -6,-2 -6,-5l0 -56c0,-3 3,-5 6,-5l137 0c3,0 5,2 5,5l0 39c0,1 1,3 3,3 2,0 3,-2 3,-3l0 -39c0,-6 -5,-12 -11,-12l-137 0c-7,0 -12,6 -12,12l0 56c0,6 5,11 12,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M24 66l30 0c2,0 3,-1 3,-3 0,-2 -1,-3 -3,-3l-30 0c-2,0 -3,1 -3,3 0,2 1,3 3,3z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.7bac3ca6378e721a32d493ea6a26cfbf.svg";
export { ForwardRef as ReactComponent };